import { appState } from '../../../../../interfaces/common';
import { Avatar, Flex, Text } from '@pega/cosmos-react-core';
import React from 'react';
import { useSelector } from 'react-redux';

import useLocalTranslation from '../../../../../hooks/useLocalTranslation';
import { csrChatContentStyle, cxChatAvatarStyle, cxChatContentStyle } from '../../../../cosmos-social/Message.styles';

interface TextMessageProps {
  messageFrom: string;
  csrName?: string;
  message: string;
  selectedThemeColor?: any;
}

export type ColorBgProp = {
  bgColor: string;
  color: string;
};

const TextMessage: React.FC<TextMessageProps> = ({ messageFrom, csrName = '', message }) => {
  const translate = useLocalTranslation();

  const {
    chatInfo: {
      enableAvatars,
      csrAvatar,
      botAvatar,
      userAvatar,
      isUserAvatarHidden,
      isBotAvatarHidden,
      isCsrAvatarHidden,
      botBgColor = '',
      botFontColor = '',
      csrBgColor = '',
      csrFontColor = '',
      userBgColor = '',
      userFontColor = '',
      colorTheme,
      enableMessageFontColor,
    },
  } = useSelector((state: appState) => {
    return {
      chatInfo: state.chatInfo,
    };
  });

  const csrNameStyle = {
    fontSize: '0.60rem',
    fontWeight: 600,
    color: '#71728A',
    width: '100%',
    paddingLeft: enableAvatars && !isCsrAvatarHidden ? '3rem' : '0.5rem',
    marginTop: '0.1rem',
  };

  const botIconStyle = {
    minHeight: '2rem',
    maxHeight: '2rem',
    minWidth: '2rem',
    maxWidth: '2rem',
    color: '#ffffff',
    backgroundColor: '#48626a',
    cursor: 'default',
    marginTop: '2.2rem',
  };

  const setPadding = () => {
    const paddingData = { botPadding: '', csrPadding: '', userPadding: '' };
    if (enableAvatars) {
      paddingData.botPadding = isBotAvatarHidden ? '0.3rem' : '2.5rem';
      paddingData.csrPadding = isCsrAvatarHidden ? '0.3rem' : '2.5rem';
      paddingData.userPadding = isUserAvatarHidden ? '0.3rem' : '2.5rem';
    }
    return paddingData;
  };
  const isCxDefaultAvatar = csrName === 'cx' && !userAvatar && !isUserAvatarHidden;

  const setBgFontColor = () => {
    const colorConfig = { color: '', bgColor: '' };
    if (enableMessageFontColor) {
      if (csrName && csrName !== 'cx') {
        colorConfig.color = csrFontColor;
        colorConfig.bgColor = csrBgColor;
      } else if (csrName === 'cx') {
        colorConfig.color = userFontColor;
        colorConfig.bgColor = userBgColor;
      } else {
        colorConfig.color = botFontColor;
        colorConfig.bgColor = botBgColor;
      }
    } else if (csrName && csrName === 'cx') {
      colorConfig.color = '#ffffff';
      colorConfig.bgColor = colorTheme;
    }
    return colorConfig;
  };

  const { botPadding, csrPadding, userPadding } = setPadding();
  const { color, bgColor } = setBgFontColor();

  const chatTextMessageStatus = {
    fontSize: '9px',
    fontWeight: 500,
    color: '#71728A',
    paddingLeft: messageFrom === 'bot' ? botPadding : messageFrom === 'csr' ? csrPadding : '',
    paddingRight: messageFrom === 'user' ? userPadding : '',
  };

  return (
    <Flex
      container={{
        direction: 'column',
        alignItems: ['bot', 'csr'].includes(messageFrom) ? 'start' : 'end',
        justify: 'start',
      }}
    >
      {csrName && csrName !== 'cx' && <Text style={csrNameStyle}>{csrName}</Text>}

      <Flex container={{ direction: messageFrom === 'user' ? 'row-reverse' : 'row', gap: 1 }}>
        {['bot', 'csr', 'user'].includes(messageFrom) && enableAvatars ? (
          (!csrName && !botAvatar && !isBotAvatarHidden) || (isCxDefaultAvatar && !isUserAvatarHidden) ? (
            <Avatar
              style={botIconStyle}
              variant="primary"
              name=""
              icon={isCxDefaultAvatar ? 'user-solid' : 'robot-solid'}
              shape="circle"
              data-testid="bot_avatar"
            />
          ) : csrName && csrName === 'cx' && !isUserAvatarHidden ? (
            <Avatar name={csrName} imageSrc={userAvatar} style={{ marginTop: '2.2rem' }} />
          ) : csrName && csrName !== 'cx' && !isCsrAvatarHidden ? (
            <Avatar name={csrName} imageSrc={csrAvatar} style={{ marginTop: '2.2rem' }} />
          ) : (
            !isBotAvatarHidden &&
            csrName === '' && <Avatar name={csrName} imageSrc={botAvatar} style={{ marginTop: '2.2rem' }} />
          )
        ) : (
          <></>
        )}
        <Flex
          as={
            ['bot', 'csr'].includes(messageFrom)
              ? csrChatContentStyle
              : ['user'].includes(messageFrom) && enableAvatars
              ? cxChatAvatarStyle
              : cxChatContentStyle
          }
          bgColor={bgColor}
          color={color}
        >
          <Text style={{ fontSize: '13px', fontWeight: 500 }}>{translate(message)}</Text>
        </Flex>
      </Flex>
      <Text style={chatTextMessageStatus}>{'11:30 AM'}</Text>
    </Flex>
  );
};

export default TextMessage;
